import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Alert } from './alert';
import { FilterComponent, FilterOptions, FilterBuilder, mapCollection, AuthorizationSchemeService, FilterProperty, toSentenceCase, AutocompleteDataSourceFn, MgAutocompleteData, FilterFormComponent, MgFormControlDirective } from '@mango/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'dla-app-alert-filter',
    templateUrl: './alert-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FilterFormComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatIconButton, MatSuffix, MatIcon]
})
export class AlertFilterComponent extends FilterComponent<Alert> {
	constructor(
		injector: Injector) {
		super(Alert, new FilterOptions<Alert>()
			.like("title")
			.like("message")

		);
	}

	ngOnInit() {
		super.ngOnInit();
	}
}